
import { ISetTieuChuanSanPhamActions } from "../../action-types/set-tieu-chuan/ISetTieuChuanSanPhamActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { ISetTieuChuanSanPhamReducer } from "../../reducer-model/set-tieu-chuan/ISetTieuChuanSanPhamReducer";
const iniState: ISetTieuChuanSanPhamReducer = {
    status: eReducerStatusBase.is_not_initialization,
    setTieuChuanSanPhams: [],
    setTieuChuanSanPhamDetails: []

}
export const setTieuChuanSanPhamReducer = (state: ISetTieuChuanSanPhamReducer = iniState, action: ISetTieuChuanSanPhamActions): ISetTieuChuanSanPhamReducer => {
    switch (action.type) {
        case "SET_TIEU_CHUAN_SAN_PHAM_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case "SET_TIEU_CHUAN_SAN_PHAM_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                setTieuChuanSanPhams: action.payload
            }
        case "SET_TIEU_CHUAN_SAN_PHAM_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }

        case "SET_TIEU_CHUAN_SAN_PHAM_LOAD_DETAIL_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case "SET_TIEU_CHUAN_SAN_PHAM_LOAD_DETAIL_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                setTieuChuanSanPhamDetails: action.payload
            }
        case "SET_TIEU_CHUAN_SAN_PHAM_LOAD_DETAIL_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "SET_TIEU_CHUAN_SAN_PHAM_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                setTieuChuanSanPhamEditing: action.payload
            }
        case "SET_TIEU_CHUAN_SAN_PHAM_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "SET_TIEU_CHUAN_SAN_PHAM_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "SET_TIEU_CHUAN_SAN_PHAM_SAVE_SUCCESS":
            return {
                ...state,
                isShowEditModal: false,
                status: eReducerStatusBase.is_need_reload
            }
        case "SET_TIEU_CHUAN_SAN_PHAM_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "SET_TIEU_CHUAN_SAN_PHAM_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting
            }
        case "SET_TIEU_CHUAN_SAN_PHAM_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload
            }
        case "SET_TIEU_CHUAN_SAN_PHAM_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        default:
            return state;
    }
}